document.addEventListener("DOMContentLoaded", (event) => {
  /*document.querySelectorAll("*").forEach((element) => {
    element.addEventListener("focus", function(event) {
        console.log("Focus Element");
        console.log(event.target);
    });
  });*/

  /*let linkedSlideShows = document.querySelectorAll(".linked-mini-blocks");
  if (linkedSlideShows) {
    linkedSlideShows.forEach((slideshow) => {
      let section = slideshow.closest(".shopify-section.section.slideshow-banner-section");
      let slideDots = slideshow.querySelectorAll(".slider-counter.slider-counter--dots .slider-counter__link.slider-counter__link--dots");
      let index = 0;
      let miniBlockSection = section.nextElementSibling;
      let miniBlocks = miniBlockSection.querySelectorAll(".mini-block");
      if (miniBlockSection && slideDots && miniBlocks) {
        slideDots.forEach((dot, index) => {
          if (dot.classList.contains("slider-counter__link--active")) {
            miniBlocks[index].classList.add("mini-block--active");
          } else {
            if (miniBlocks[index]) {
              miniBlocks[index].classList.remove("mini-block--active");
            }
          }
        });
      }

      slideshow.addEventListener("slideChanged", function(event) {
        let newIndex = event.detail.currentPage - 1;
        miniBlocks.forEach((block, index) => {
          if (index == newIndex) {
            miniBlocks[index].classList.add("mini-block--active");
          } else {
            miniBlocks[index].classList.remove("mini-block--active");
          }
        });

      }); 
    });
  }*/

  // Remove inert from searchbar on media size
  const targetElement = document.querySelector('.header-search-below.toggled');
  const searchInput = document.querySelector('.search__input');

  function updateSearchState() {
    if (!targetElement) return;
    const hasText = searchInput ? searchInput.value.trim().length > 0 : false;
    targetElement.classList.toggle('active', hasText);

    if (hasText || window.innerWidth < 1348) {
      targetElement.removeAttribute('inert');
    } else {
      targetElement.setAttribute('inert', '');
    }
  }

  updateSearchState();
  window.addEventListener('resize', updateSearchState);

  if (searchInput) {
    searchInput.addEventListener('input', updateSearchState);
  }

});